import {
    Form, FormButton, FormButtonContainer, FormItem, OptionProps,
    DateInput, TimeInput, DateTimeInput, MaskedInput, SelectInput, TextInput, useAlerts,    
    useForm,
    FormSubmitHandler
} from "@sis/react-library"
import { ExampleDto } from "./FormSamplesNoFeedbackPage";

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends ExampleDto { }

interface FormSamplesNoFeedbackFormProps {
    onSubmit: FormSubmitHandler<ExampleDto>;
    submitting: boolean;
}

export const FormSamplesNoFeedbackForm = ({
    onSubmit, submitting
}: FormSamplesNoFeedbackFormProps) => {

    const formName = 'FormNoFeedback';

    const selectOptions: OptionProps[] = [
        { value: "Op1", description: "Option 1", filter: "Option 1" },
        { value: "Op2", description: "Option 2", filter: "Option 2" },
        { value: "Op3", description: "Option 3", filter: "Option 3" },
        { value: "Op4", description: "Option 4", filter: "Option 4" }
    ]

    const { resetForm } = useForm<T>(formName);
    const { confirm } = useAlerts();

    const handleCancel = () => {
        confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
            () => { resetForm() },
            "Yes", "No"
        );
    }

    return (
        /////////////////////////////////////////////////////////////////////////////////////////////
        // If you don't want to show the green ticks after an input control is changed,
        // you can do the following
        // - Add a noFeedback prop to the formItem component for individual no feedbacks
        // - For an entire form you can add the noFeedbackForm prop to the Form Component        
        /////////////////////////////////////////////////////////////////////////////////////////////
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            noFeedbackForm
            beforeLeaveText='You have made changes, are you sure you want to leave ?'
        >
            <FormItem<T>
                formField="textBox"
                label="Text Box"
                //////////////////////////////////////////////////////////////////////////////////////
                // Instead of doing a form level noFeedback, you can do individually like the
                // commented out line below
                //////////////////////////////////////////////////////////////////////////////////////
                // noFeedback
                element={<TextInput />}
            />
            <FormItem<T>
                formField="date"
                label="Date"
                element={<DateInput />}
            />
            <FormItem<T>
                formField="time"
                label="Time"
                element={<TimeInput />}
            />
            <FormItem<T>
                formField="dateTime"
                label="Date Time"
                element={<DateTimeInput />}
            />
            <FormItem<T>
                formField="singleSelect"
                label="Single Select"
                noFeedback={false} // This control feedback is overwritten and therefore will show
                element={<SelectInput options={selectOptions} />}
            />
            <FormItem<T>
                formField="multipleSelect"
                label="Multiple Select"
                element={<SelectInput isMultiSelect options={selectOptions} />}
            />
            <FormItem<T>
                formField="maskTelephone"
                label="Mask Phone Number"
                element={<MaskedInput maskedType="PhoneNumber" />}
            />
            <FormItem<T>
                formField="maskOther"
                label="Mask Other"
                element={<MaskedInput mask="(000) (000)" />}
            />
            <FormButtonContainer>
                <FormButton
                    formButtonText='Cancel'
                    onClick={() => { handleCancel() }}
                />
                <FormButton
                    formButtonText='Submit'
                    submitButton
                />
            </FormButtonContainer>
        </Form>
    )
}